import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';

import type { TreatmentPlanV3PageLoadStateProps } from './types';

// A failed reload can leave the previous page in the store, so the error is checked first.
export default function TreatmentPlanV3PageLoadState({
  hasLoaded,
  hasLoadError,
  errorMessage,
  onRetry,
  children,
}: TreatmentPlanV3PageLoadStateProps) {
  if (hasLoadError) {
    return (
      <Stack gap={1} alignItems="flex-start">
        <Typography>{errorMessage}</Typography>
        <Button onClick={onRetry} variant="contained">
          Retry
        </Button>
      </Stack>
    );
  }

  if (hasLoaded) {
    return <>{children}</>;
  }

  return (
    <Box display="flex" justifyContent="center" py={4}>
      <CircularProgress size={32} />
    </Box>
  );
}
